/* @flow */
// typecheck: ignore file
import React from 'react';
import Button from 'components/Button.jsx';
import Glyph from 'components/Glyph.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import Hovercard from 'components/Hovercard.jsx';
import HovercardBody from 'components/HovercardBody.jsx';
import SmartTableFilters from 'components/SmartTableFilters.jsx';
import type { Filter } from 'components/SmartTable.jsx';

type Props = {
  filters: Filter[],
};

class SmartTableFilterIcon extends React.Component {
  props: Props;

  static contextTypes = {
    namespace: React.PropTypes.string.isRequired,
  };

  render() {
    const layer = (
      <Hovercard>
        <HovercardBody>
          <SmartTableFilters data-test="table-filters" namespace={this.context.namespace} filters={this.props.filters} />
        </HovercardBody>
      </Hovercard>
    );

    return (
      <LayerTrigger ref="trigger" layer={layer} trigger="click" alignment="left" placement="bottom">
        <Button level="icon" color="thunder">
          <Glyph name="sort" color="thunder" size="xlarge" />
        </Button>
      </LayerTrigger>
    );
  }
}

export default SmartTableFilterIcon;



// WEBPACK FOOTER //
// ./src/components/SmartTableFilterIcon.jsx